import { useEffect } from 'react';
import { SignupMethod } from 'js/auth/types/signup';
import { getClearbitData, trackRegistrationData } from 'js/auth/utils/analyticsUtils';
import analytics from 'js/project/common/util/segmentAnalytics';
import { Search } from 'js/auth/types/search';
import { useRequestParams } from 'js/common/context/RequestParamsContext';
import Cookies from 'js-cookie';

export function useGoogleAnalytics(parsedSearchLocation: Search, appUserParams) {
  const { uId, company, signupSource, signupMethod, referrer } = parsedSearchLocation;
  const { analyticsEnabled, eloquaSiteId } = useRequestParams();

  useEffect(() => {
    if (analyticsEnabled && appUserParams.username && signupMethod === SignupMethod.GOOGLE) {
      const decodedCompany = company?.replace(/\+/g, ' ');
      const { username, firstName, lastName, country } = appUserParams;
      const clearbitData = getClearbitData();
      const data = {
        email: username,
        ...clearbitData,
        first_name: firstName,
        last_name: lastName,
        company: decodedCompany,
        country,
        referrer,
        signup_source: signupSource ? signupSource.replace(/\+/g, ' ') : undefined,
        signup_method: signupMethod ? signupMethod.replace(/\+/g, ' ') : undefined,
        optimizelyEndUserId: Cookies.get('optimizelyEndUserId'),
      };

      const anonymousId = analytics.user()?.anonymousId();
      trackRegistrationData({
        eloquaSiteId,
        parsedSearchLocation,
        anonymousId,
        userId: uId,
        data,
      });
    }
  }, [appUserParams.username, appUserParams.firstName, appUserParams.lastName, appUserParams.country]);
}
